/* eslint-disable no-restricted-syntax */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {
  iconCompleted,
  iconInProgress,
  iconPending,
} from '~/pages/RedemptionMall/pages/store/components/task/components/Daily/images'

export enum TaskTypeEnum {
  新手进阶 = 1,
  星光币消费 = 2,
  连续保级 = 3,
  高等级升级 = 4,
}

export enum StatusEnum {
  未完成 = 0,
  可领取 = 1,
  已领取 = 2,
}

export const get_vip_exchange_goods = createAsyncThunk(
  'RedemptionMall/get_vip_exchange_goods',
  async (params: any, store: any) => {
    const {from} = store.getState().env.otherInfo
    const resp = await http.post(
      '/live/vip/get_vip_exchange_goods',
      {from},
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const common_mission_entrance = createAsyncThunk(
  'RedemptionMall/common_mission_entrance',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/vip/common_mission_entrance',
      {},
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const common_mission_complete = createAsyncThunk(
  'RedemptionMall/common_mission_complete',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/vip/common_mission_complete',
      {...params},
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const season_mission_entrance = createAsyncThunk(
  'RedemptionMall/season_mission_entrance',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/vip/season_mission_entrance',
      {...params},
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const season_mission_complete = createAsyncThunk(
  'RedemptionMall/season_mission_complete',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/vip/season_mission_complete',
      {...params},
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const batch_claim_mission_rewards = createAsyncThunk(
  'RedemptionMall/batch_claim_mission_rewards',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/vip/batch_claim_mission_rewards',
      {...params},
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export interface InitialStateType {
  mall: any
  daily: any
  season: any
  base: any
}

const initialState: InitialStateType = {
  mall: {},
  daily: {},
  season: {},
  base: {
    fitCurTab: 0,
  },
}

export const RedemptionMallSlice = createSlice({
  name: 'RedemptionMall',
  initialState,
  reducers: {
    updateBase: (state, action: PayloadAction<any>) => {
      Object.assign(state, {
        base: {
          ...state.base,
          ...action.payload,
        },
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(get_vip_exchange_goods.fulfilled, (state, action) => {
      Object.assign(state.mall, action.payload)
    })
    builder.addCase(common_mission_entrance.fulfilled, (state, action) => {
      Object.assign(state.daily, action.payload)
    })
    builder.addCase(season_mission_entrance.fulfilled, (state, action) => {
      Object.assign(state.season, action.payload)
    })
  },
})
export default RedemptionMallSlice.reducer
export const RedemptionMallActions = RedemptionMallSlice.actions

export const useRedemptionMallState = () =>
  useSelector((store) => store.RedemptionMall) as InitialStateType
